import { tagsSelectorComponent } from './tags-selector.component';
import { TagsSelectorService } from './tags-selector.service';

export default angular
  .module('sfMobile.tags-selector', [])
  .component('sfTagsSelector', tagsSelectorComponent)
  .service('tagsSelectorService', TagsSelectorService).name;
